import React, { useEffect, useState } from "react";
import { getUserDetails } from "sr/helpers/functions/getUserDetails";
import ContentWithSpinner from "sr/layout/common/ContentWithSpiner";
import { createWidgetToken } from "sr/utils/api/cleaner/trolley/createWidgetToken";

export const PaymentDetails = () => {
    const [userId, setUserId] = useState<string>('')
      const [loader, setLoader] = useState(true)
      const [widgetUrl, setWidgetUrl] = useState('')
      useEffect(()=>{
          const {user_id} = getUserDetails()
          setUserId(user_id)
      },[]) 
   
      useEffect(()=>{
            const getToken = async ()=>{
                try {
              const queryParams = new URLSearchParams()
              queryParams.append('user_id', userId)
              const res = await createWidgetToken(queryParams)
              if(res?.success===true){
                setLoader(false)
                setWidgetUrl(res?.data?.widgetUrl)
                
              }
              else {
                setLoader(false)
              }
            }
            catch(e){
                setLoader(false)
            }
            }
            if(userId){
                getToken()
            }
    },[userId])
  return( <div>
     <ContentWithSpinner loader={loader} height="min-h-[50vh]">
    {widgetUrl &&
    <iframe
  src={widgetUrl}
  style={{ width: "100%", height: "600px", border: "none" }}
  title="Trolley Recipient Widget"
/>
}
</ContentWithSpinner>

  </div>);
};
